<template>
  <v-container fluid class="no-margins">
    <Sitetour :open="openGuide"></Sitetour>
    <Welcome />
  </v-container>
</template>

<script>
import Welcome from '@/components/Welcome'
import Sitetour from '@/components/common/Sitetour.vue'
import {mapActions, mapGetters} from 'vuex'
// @group Common
// LoggedInLayout component
export default {
  name: 'LoggedInLayout',
  data: () => ({
    openGuide: false
  }),
  props: {
    guide: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    guide: function () {
      //this.openGuide = this.guide
      init()
    }
  },
  components: {
    Welcome,
    Sitetour
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser'])
  },
  created() {
    this.init()
  },

  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),
    /**
     * @vuese
     * Used to open the site tour if it is the user's first time logged in 
     */
    init() {            
      if (this.currentUser.firstLogin == true) {
        
        this.openGuide = true        
        
        if (this.$vuetify.breakpoint.mdAndUp == true) {
          this.$events.fire('openLeftMenu')
        } else {
          this.$events.fire('closeLeftMenu')
        }
        this.currentUser.firstLogin = false
        this.setCurrentUser(this.currentUser)
      }
      else {
        this.openGuide = this.guide    
      }
    }
  }
}
</script>

<style scoped>
</style>